// Re-export shared theme utility
export { mergeTheme } from "./utils/theme";

// Re-export everything from nav-header
export { NavHeader, createButton } from "./nav-header";
export type {
  NavHeaderProps,
  NavHeaderAction,
  NavHeaderTheme,
  ButtonFactoryProps,
} from "./nav-header/types";
export { defaultTheme as navHeaderDefaultTheme } from "./nav-header/themes";

// Re-export everything from footer-with-children
export { FooterWithChildren } from "./footer-with-children";
export type {
  FooterWithChildrenProps,
  FooterWithChildrenTheme,
} from "./footer-with-children/types";
export { defaultTheme as footerDefaultTheme } from "./footer-with-children/themes";

// Re-export everything from action-button
export { ActionButton } from "./action-button";
export type {
  ActionButtonProps,
  ActionButtonTheme,
  ActionButtonEventData,
} from "./action-button/types";
export { defaultTheme as actionButtonDefaultTheme } from "./action-button/themes";

// Re-export everything from patient-selector
export {
  PatientSelector,
  PatientSelectorModal,
  PatientListItem,
} from "./patient-selector";
export type {
  Patient,
  PatientSelectorProps,
  PatientSelectorTheme,
  PatientSelectorModalProps,
  PatientSelectorModalTheme,
  PatientListItemProps,
  PatientListItemTheme,
} from "./patient-selector";
export {
  defaultSelectorTheme,
  defaultModalTheme,
  listLayoutTheme,
} from "./patient-selector/themes";

// Re-export everything from visit-list
export {
  VisitList,
  VisitListItem,
  AvatarGroup,
  VisitStatus,
} from "./visit-list";
export type {
  VisitData,
  VisitListData,
  VisitListProps,
  VisitListItemProps,
  AvatarGroupProps,
  VisitStatusProps,
  VisitListTheme,
  VisitListItemTheme,
  AvatarGroupTheme,
  VisitStatusTheme,
} from "./visit-list";
export {
  defaultVisitListTheme,
  defaultVisitListItemTheme,
  defaultAvatarGroupTheme,
  defaultVisitStatusTheme,
} from "./visit-list";
